import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { StakeCheckingWizard } from "../../Organisms/Modals/Stake Checking Status/stake-checking-onboarding-step";
import { useStakeDebit } from "../../CustomHooks/Queries";
import { useAppUtilityContext } from "../../Contexts/AppUtilityContext";
import {
  BATTLECARD_FLOW_NAV_STATE,
  isSVDDepositAccountCreated,
} from "../../Utils/helpers";
import BattlecardHeaderLayout from "./battlecard-header-layout";
import "./battle-cards.scss";

export default function MemberSetup() {
  const navigate = useNavigate();
  const { setAppUtilityProps } = useAppUtilityContext();
  const { isFetching: isFetchingStakeDebit, data: stakeDebitData } = useStakeDebit();

  useEffect(() => {
    setAppUtilityProps((p) => ({ ...p, hideNavigationBar: true, lockedRoutes: ["/deals", "/cash"] }));
    return () => setAppUtilityProps((p) => ({ ...p, lockedRoutes: [] }));
  }, [setAppUtilityProps]);

  useEffect(() => {
    if (!isFetchingStakeDebit && isSVDDepositAccountCreated(stakeDebitData?.data)) {
      navigate("/battlecard/add-funds", { replace: true, state: BATTLECARD_FLOW_NAV_STATE });
    }
  }, [isFetchingStakeDebit, navigate, stakeDebitData]);

  const goToHomeRefreshed = () => {
    window.location.assign("/home");
  };

  return (
    <BattlecardHeaderLayout>
      <div className="battle-cards-page bc-member-setup-page">
        <StakeCheckingWizard
          variant="page"
          onExit={() => navigate("/battlecard", { state: BATTLECARD_FLOW_NAV_STATE })}
          onComplete={goToHomeRefreshed}
        />
      </div>
    </BattlecardHeaderLayout>
  );
}
